import { Progress } from '@admin/components/progress/progress.tsx';
import { Card, CardContent } from '@r/components/ui/card.tsx';
import { Award } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { LogicTypeTargetStatusCompanyReadModel } from '@r/api/generated/client.schemas.ts';

interface CompanyTargetProps {
  targetStatus: LogicTypeTargetStatusCompanyReadModel;
  isTargetPointLogic?: boolean;
  currencySymbol?: string;
}

const CompanyTarget = ({
  targetStatus,
  isTargetPointLogic = false,
  currencySymbol
}: CompanyTargetProps) => {
  const { t } = useTranslation();

  const progressPercentage = Math.min((targetStatus.value / targetStatus.targetValue) * 100, 100);

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-4 gap-6">
        <Card className="col-span-1">
          <CardContent className="pt-6">
            <div className="flex items-center space-x-2.5 mb-2">
              <Award className="w-5 h-5" />
              <h3 className="font-semibold">
                {t('admin.company.target.obj.title')} {targetStatus.logicTypeTarget?.reference}
              </h3>
            </div>
            <div className="text-4xl font-bold">
              {progressPercentage.toFixed(2).replace('.00', '')}
              {'%'}
              <span className="ml-2 text-sm font-normal text-muted-foreground">
                {t('admin.company.target.reached')}
              </span>
            </div>
          </CardContent>
        </Card>

        <Card className="col-span-3">
          <CardContent className="pt-6">
            <div className="space-y-3">
              <Progress
                value={progressPercentage}
                max={targetStatus.targetValue}
                isTargetPointLogic={isTargetPointLogic}
                tooltipValue={targetStatus.value}
                tooltipValueSuffix={isTargetPointLogic ? undefined : ` ${currencySymbol ?? ''}`}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CompanyTarget;
